/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useShallow } from "zustand/react/shallow";
import { createFormStore, FormStoreBase } from "./createFormStore";

type FastContextType = FormStoreBase<Record<string, any>>;

export type HandleChangeStore = FastContextType["set"];

export type HandleChangeValues = FastContextType["setValues"];

export const fastContext = createFormStore<FastContextType>();

const { useStore } = fastContext;

/**
 * useStoreSetters function.
 *
 * @returns {*} Return value description
 */
export const useStoreSetters = (): Pick<
  FastContextType,
  "set" | "setValues" | "updateValues"
> => {
  return useStore(
    useShallow((state) => ({
      set: state.set,
      setValues: state.setValues,
      updateValues: state.updateValues,
    }))
  ) as {
    set: HandleChangeStore;
    setValues: HandleChangeValues;
    updateValues: HandleChangeValues;
  };
};
